export default __webpack_public_path__ + "static/media/sketch.353f97de.svg";